import React from 'react';
import cx from 'clsx';

import styles from '@danske/sapphire-css/components/skeleton/skeleton.module.css';

import { useSapphireStyleProps, useThemeCheck } from '../../utils';
import { getAnimationDelay } from './animation';
import { SkeletonProps } from './skeleton.model';

export type SkeletonCircleProps = SkeletonProps;

export const SkeletonCircle: React.FC<SkeletonCircleProps> = ({
  index,
  children,
  ...rest
}) => {
  useThemeCheck();

  const { styleProps } = useSapphireStyleProps(rest);

  const animationDelay = getAnimationDelay(index);

  return (
    <div
      {...rest}
      style={{
        animationDelay,
        ...styleProps.style,
      }}
      className={cx(
        styles['sapphire-skeleton'],
        styles['sapphire-skeleton--circle'],
        styleProps.className
      )}
    />
  );
};
